// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1BHVP","col":"styles_col__16Zg2","fulfillmentStatus":"styles_fulfillmentStatus__3yORS","emailCol":"styles_emailCol__3RIwz"};